import { State, PortalRouteParams, ExtraUserInfo } from "../portal_client";
import { AppState } from "../../components/portal/state";

export let events_object = {
    on_login: (s:AppState<State, PortalRouteParams, ExtraUserInfo>):AppState<State, PortalRouteParams, ExtraUserInfo> => s
  }